import { styled, Typography } from '@mui/material';

interface StyledTabIndicatorProps {
  hasVisitedPage: boolean;
}

export const StyledTabIndicator = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'hasVisitedPage',
})<StyledTabIndicatorProps>(({ hasVisitedPage }) => ({
  fontFamily: 'Instrument Sans',
  padding: '0.3125rem',
  background: '#EAEEFF',
  borderRadius: '50%',
  width: '1.75rem',
  height: '1.75rem',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  color: hasVisitedPage ? '#000' : '#436eb2',
}));
